<template>
  <div>
    <CountHeader header="แก้ไขข้อมูลรอบนับสต๊อก" :img_header="header_image" link_back="count_stock/historylist"/>
    <Count_Edit/>
  </div>
</template>

<script>
import CountHeader from "@/components/admin/count_stock/headercount_stock/CountHeader";
import HeaderImage from "@/assets/checklist.png";
import Count_Edit from "@/components/admin/count_stock/Count_Edit";
export default {
  name: "CountEdit",
  components: {
    Count_Edit,
    CountHeader
  },
  data() {
    return {
      header_image: HeaderImage
    }
  }
}
</script>

<style scoped>

</style>
